import React, { useState, useEffect, useContext } from "react";
import "./Activites.css";
import AsksActivity from "./Asks Activity/AsksActivity";
import InvitesPending from "./Invites Pending/InvitesPending";
import Invites from "./Invites/Invites";
import SaysActivity from "./Says Activity/SaysActivity";
import TagActtivity from "./Tag Activity/TagActtivity";
import UpdateActtivity from "./Update Activity/UpdateActtivity";
import { useDispatch } from "react-redux";
import * as ActivityActions from "../../../store/actions/Activity/ActivityAction";
import API from "../../../network";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import BlockedCommunities from "./BlockedCommunities/BlockedCommunities";
import AnswerActivity from "./AnswerActivity/AnswerActivity";
import ReplyActivity from "./ReplyActivity/ReplyActivity";

function Activites() {
  const [activityCountRes, setActivityCountRes] = useState({});
  const [isCountLoading, setIsCountLoading] = useState(true);
  const dispatch = useDispatch;
  const commonModalContext = useContext(CommonModalContext);

  const getData = async () => {
    try {
      const res = await API.getActivityPostCount();
      setActivityCountRes(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsCountLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const onHashTagClick = (hashTag) => {
    if (typeof hashTag === "object") {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
        hashTag: hashTag.hashtag,
        tagActivityTenantId: hashTag.tenantId,
      });
    } else {
      commonModalContext?.onOpen(ModalType.SEARCH_TAG, { hashTag });
    }
  };

  const decreaseHashCount = () => {
    if (activityCountRes?.hashListSize > 0) {
      const newActivityHashCount = activityCountRes.hashListSize - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        hashListSize: newActivityHashCount,
      }));
    }
  };

  const decreaseActivitySaysCount = () => {
    if (activityCountRes?.allsayscount > 0) {
      const newActivitySayCount = activityCountRes.allsayscount - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        allsayscount: newActivitySayCount,
      }));
    }
  };
  const decreaseActivityAnswersCount = (count) => {
    if (activityCountRes?.allanswersactivitycount > 0) {
      const newActivityAnswersCount =
        activityCountRes.allanswersactivitycount - count;

      setActivityCountRes((prevState) => ({
        ...prevState,
        allanswersactivitycount: newActivityAnswersCount,
      }));
    }
  };

  const decreaseActivityRepliesCount = () => {
    if (activityCountRes?.hashSayListSize > 0) {
      const newActivityRepliesCount = activityCountRes.hashSayListSize - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        hashSayListSize: newActivityRepliesCount,
      }));
    }
  };

  const decreaseActivityReceiveCount = () => {
    getData();
  };

  const decreaseActivityAskCount = () => {
    if (activityCountRes?.allasksactivitycount > 0) {
      const newActivityAskCount = activityCountRes.allasksactivitycount - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        allasksactivitycount: newActivityAskCount,
      }));
    }
  };
  const decreaseActivityUpdateCount = () => {
    if (activityCountRes?.allasksactivitycount > 0) {
      const newActivityUpdateCount = activityCountRes.updatesListSize - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        updatesListSize: newActivityUpdateCount,
      }));
    }
  };
  const decreaseActivityTagCount = () => {
    if (activityCountRes?.allasksactivitycount > 0) {
      const newActivityTagCount = activityCountRes.hashListSize - 1;

      setActivityCountRes((prevState) => ({
        ...prevState,
        hashListSize: newActivityTagCount,
      }));
    }
  };

  return (
    <div className="Activites">
      <div>
        <p className="head">Activity </p>
        <AsksActivity
          activityCountRes={activityCountRes}
          decreaseActivityAskCount={decreaseActivityAskCount}
          onHashTagClick={onHashTagClick}
          isCountLoading={isCountLoading}
        />
        <SaysActivity
          activityCountRes={activityCountRes}
          decreaseActivitySaysCount={decreaseActivitySaysCount}
          onHashTagClick={onHashTagClick}
          isCountLoading={isCountLoading}
        />
        <UpdateActtivity
          onHashTagClick={onHashTagClick}
          activityCountRes={activityCountRes}
          isCountLoading={isCountLoading}
          decreaseActivityUpdateCount={decreaseActivityUpdateCount}
        />
        <TagActtivity
          activityCountRes={activityCountRes}
          decreaseHashCount={decreaseHashCount}
          onHashTagClick={onHashTagClick}
          isCountLoading={isCountLoading}
          decreaseActivityTagCount={decreaseActivityTagCount}
        />
        <AnswerActivity
          activityCountRes={activityCountRes}
          decreaseActivityAnswersCount={decreaseActivityAnswersCount}
          onHashTagClick={onHashTagClick}
          isCountLoading={isCountLoading}
        />
        <ReplyActivity
          activityCountRes={activityCountRes}
          decreaseActivityRepliesCount={decreaseActivityRepliesCount}
          onHashTagClick={onHashTagClick}
          isCountLoading={isCountLoading}
        />
        <InvitesPending
          activityCountRes={activityCountRes}
          decreaseActivityReceiveCount={decreaseActivityReceiveCount}
        />
        <Invites activityCountRes={activityCountRes} />
        <BlockedCommunities />
      </div>
    </div>
  );
}
export default Activites;
